const button = document.querySelector('[data-back-to-top]');

if (button) {
  let frame = 0;
  const update = () => {
    frame = 0;
    button.hidden = window.scrollY < 400;
  };
  const scheduleUpdate = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  button.addEventListener('click', () => {
    document.querySelector('.brand')?.focus({ preventScroll: true });
    // CSS scroll-behavior also respects the reduced-motion preference.
    window.scrollTo({ top: 0, behavior: 'auto' });
  });
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('pageshow', scheduleUpdate);
  update();
}
